import * as types from '../_actions/actionTypes'
import _ from 'lodash'

export function payrollDefaultWorkHour(state = {}, action) {
    switch (action.type) {
        case types.FETCH_EMP_DEFAULT_WORKHOUR:
            return {
                ...state,
                ...action.payload.payrollDefaultWorkHour,
            }
        case types.FETCH_EMP_DEFAULT_WORKHOUR_FAILURE:
            return state
        default:
            return state
    }
}
